import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

@Component({
	selector: "custom-form-segment",
	template: `
		<div class="dynamic-field form-segment" [formGroup]="group">
			<ng-content select="h3" />

			<segment [formControlName]="config.name" [options]="config.options" />
		</div>
	`,
	styleUrls: ["segment.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class FormSegmentComponent {
	@Input() config: any;
	// @ts-expect-error TS2564
	@Input() group: UntypedFormGroup;
}
